import { ICreateSystem } from '../../system/types';

export const SYSTEM_FORM_INITIAL_STATE: ICreateSystem = {
  title: '',
};
